<template>
  <div class="project-post-list">
    <div v-for="post in $store.state.posts">
      <img :src="post.author.iconUrl">
      <div class="inline-title">
        <a :href="`/projects/${post.project.id}/discussions/${post.postNumber}`">
          {{post.title}}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
 export default {
   created() {
     this.$store.dispatch('loadPosts', {
       projectId: this.$store.state.currentProject.id,
     });
   },

   methods: {
   }
 }
</script>



// WEBPACK FOOTER //
// assets/js/components/PostList.vue